import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../components/NavBar';
import Footer from '../../components/Footer';
import './Product.css';

const Product = () => {
    return (
        <div className="d-flex flex-column" style={{ height: '100vh' }}>
            <NavBar />
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
                <div className="custom-container px-5">
                    <h1
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1rem, 2vw, 1.5rem)'
                        }}
                        className='text-center mt-3'
                    >
                        Những sản phẩm của An Classical sẽ sớm được ra mắt
                    </h1>

                    <img src={'/ic_waiting.png'} alt="coming_soon" id='waiting_img' className='mt-3' />

                    <h1
                        style={{
                            width: '100%',
                            fontSize: 'clamp(1rem, 2vw, 1.5rem)'
                        }}
                        className='my-3 text-center'
                    >
                        Bạn hãy theo dõi An Classical trên các phương tiện truyền thông để không bỏ lỡ thông tin mới nhất nhé
                    </h1>

                    <div className="d-flex flex-row justify-content-center gap-3">
                        <Link to="#" className='' style={{ width: '50px', height: '50px' }}>
                            <img
                                src={'/tiktok_logo.png'}
                                alt="tiktok"
                                className='social-icon'
                            />
                        </Link>
                        <Link to="#" className='' style={{ width: '50px', height: '50px' }}>
                            <img
                                src={'/fb_logo.png'}
                                alt="facebook"
                                className='social-icon'
                            />
                        </Link>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Product;